import { useMutation } from "@tanstack/react-query";

import { useStoreZustandUserAuth } from "@/store-zustand/user-auth";

import { handleGetDownloadPlanilhaRemessa } from "@/domain/use-cases/remessas/get-download-planilha-remessa";
import { notifyError, notifySuccess } from "@/utils/notify-messages";

export function useDownloadRemessaPlanilha() {
  const { token: accessToken } = useStoreZustandUserAuth();

  const mutation = useMutation({
    mutationFn: async (dataRemessa: any) => {
      const nameModelo = `${dataRemessa?.numero_remessa}-${dataRemessa?.nome_identificacao}-${dataRemessa?.modelo}`;
      const formatedNamePlanilha = nameModelo?.toLocaleLowerCase()?.replace(" ", "-");

      if (!accessToken) throw new Error("Token de acesso não encontrado");
      await handleGetDownloadPlanilhaRemessa(
        accessToken,
        dataRemessa?.remessa,
        formatedNamePlanilha
      );
    },
    onSuccess: () => {
      notifySuccess("O arquivo está sendo baixado...");
    },
    onError: (error: any) => {
      notifyError(error?.response?.data?.message ?? "Falha ao gerar o arquivo.");
    },
  });

  return {
    downloadPlanilha: mutation.mutate,
    isLoading: mutation.isPending,
    isError: mutation.isError,
  };
}
